<div *ngIf="datasets && datasets.length > 0 && !showError" style="display: block;">
    <canvas baseChart [data]="chartData" [type]="Type" [options]="options"></canvas>
</div>
<div *ngIf="showError" style="display: block;">
    {{ error }}
</div>